import { render, staticRenderFns } from "./CFormPageHeaderRow.vue?vue&type=template&id=5ca527ec&scoped=true&"
import script from "./CFormPageHeaderRow.vue?vue&type=script&lang=ts&"
export * from "./CFormPageHeaderRow.vue?vue&type=script&lang=ts&"
import style0 from "./CFormPageHeaderRow.vue?vue&type=style&index=0&id=5ca527ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca527ec",
  null
  
)

export default component.exports